/**
 * Resolves the API base URL at runtime.
 * In production with a custom domain, REACT_APP_BACKEND_URL may point to the
 * build-time preview domain (e.g. *.emergent.host) which differs from the
 * custom domain (e.g. cardflow.soluwork.app). To avoid CORS issues, we detect
 * this mismatch and fall back to the current origin.
 */
const envUrl = process.env.REACT_APP_BACKEND_URL || "";

function resolveBackendUrl() {
  if (typeof window === "undefined") return envUrl;
  const currentOrigin = window.location.origin;
  // If env URL matches current origin, use it directly
  if (envUrl.includes(window.location.hostname)) return envUrl;
  // If env URL is a different host (build-time domain vs custom domain), use current origin
  if (envUrl && !envUrl.includes("localhost")) {
    try {
      const envHost = new URL(envUrl).hostname;
      const currentHost = window.location.hostname;
      if (envHost !== currentHost) {
        return currentOrigin;
      }
    } catch {
      // invalid URL, fallback
    }
  }
  return envUrl || currentOrigin;
}

export const BACKEND_URL = resolveBackendUrl();
export const API_URL = `${BACKEND_URL}/api`;
